import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";

export interface EncountersSectionProps {
  contact: TellescopeModelFromName<"endusers">;
}

export const EncountersSection = ({ contact: _ }: EncountersSectionProps) => {
  const { t } = useTranslation("encounters");
  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="text-center space-y-4">
        <div className="text-lg font-medium text-muted-foreground">{t("Encounters")}</div>
        <div className="text-sm text-muted-foreground">This component hasn't been built yet</div>
      </div>
    </div>
  );
};
